import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { DefaultResponse } from "@core/models/Http/DefaultResponse";
import { environment } from "@enviroment/environment";
import { GeneralFunctionsService } from "@core/service/generalFunctions.service";
import { PatientHealthEvent } from "@core/models/PatientHealthEvent";
import { HttpMesageHandlerService } from "@core/service/http-mesage-handler";
import { MsgResponse } from "@core/models/MsgResponse";

@Injectable({
  providedIn: 'root',
})
export class PatientHealthEventService extends UnsubscribeOnDestroyAdapter {
  isTblLoading = true;
  dataChange: BehaviorSubject<PatientHealthEvent[]> = new BehaviorSubject<PatientHealthEvent[]>([]);
  dialogData!: PatientHealthEvent;

  constructor(
    private httpClient: HttpClient,
    private readonly gfs: GeneralFunctionsService,
    private httpMsgHandler: HttpMesageHandlerService
  ) {
    super();
  }

  get data(): PatientHealthEvent[] {
    return this.dataChange.value;
  }

  getDialogData() {
    return this.dialogData;
  }

  /**
   * ✅ LISTADO
   * - idPaciente = null => token mode (no mandamos param)
   * - idPaciente = GUID => filtrar por paciente
   */
  getAllPatientHealthEvents(idPaciente: string | null = null): void {
    this.isTblLoading = true;

    const id = (idPaciente ?? '').toString().trim();

    let params = new HttpParams();
    if (id) {
      params = params.set('idPaciente', id);
    }

    this.subs.sink = this.httpClient
      .get<DefaultResponse<PatientHealthEvent[]>>(
        `${environment.backend_url}EventosSalud`,
        { params }
      )
      .subscribe({
        next: (data) => {
          const list = Array.isArray(data?.data) ? data.data : [];

          const filteredData = list.map(event => {
            const raw = (event.fecha ?? '').toString();
            return {
              ...event,
              fecha: raw.includes('T') ? raw.split('T')[0] : raw,
            };
          });

          this.isTblLoading = false;
          this.dataChange.next(filteredData);
        },
        error: (error: HttpErrorResponse) => {
          this.isTblLoading = false;
          this.httpMsgHandler.handleMsg(error);
        },
      });
  }

  addPatientHealthEvent(healthEvent: PatientHealthEvent): void {
    healthEvent.idEventoSalud = this.gfs.generateUUIDv4();
    this.httpClient.post(`${environment.backend_url}EventosSalud`, healthEvent)
      .subscribe({
        next: (res) => this.httpMsgHandler.handleMsg(res as MsgResponse),
        error: (error: HttpErrorResponse) => this.httpMsgHandler.handleMsg(error),
      });
  }

  updatePatientHealthEvent(healthEvent: PatientHealthEvent): void {
    this.httpClient.put(`${environment.backend_url}EventosSalud`, healthEvent)
      .subscribe({
        next: (res) => this.httpMsgHandler.handleMsg(res as MsgResponse),
        error: (error: HttpErrorResponse) => this.httpMsgHandler.handleMsg(error),
      });
  }

  deletePatientHealthEvent(idEventoSalud: string, idPaciente: string): void {
    const params = new HttpParams()
      .set('idEventoSalud', idEventoSalud)
      .set('IdPaciente', idPaciente);

    this.httpClient
      .delete(`${environment.backend_url}EventosSalud`, { params })
      .subscribe({
        next: (res) => this.httpMsgHandler.handleMsg(res as MsgResponse),
        error: (error: HttpErrorResponse) => this.httpMsgHandler.handleMsg(error),
      });
  }
}
